import { render, staticRenderFns } from "./CalculatorResults.vue?vue&type=template&id=1482af8b&scoped=true&"
import script from "./CalculatorResults.vue?vue&type=script&lang=js&"
export * from "./CalculatorResults.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorResults.vue?vue&type=style&index=0&id=1482af8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482af8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VIcon,VSimpleTable})
